import { connect } from 'react-redux';

import { fetchRace, setSelectedCandidate } from '../../state/actions';

import Races from './component';

const mapStateToProps = (state) => {
  const {
    candidates: {
      candidates: rootCandidates,
    },
    elections: {
      selectedElection,
    },
    races: {
      selectedRace,
    },
  } = state;

  const candidates = Object.values(rootCandidates);

  return {
    candidates,
    selectedElection,
    selectedRace,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchRace: (raceId) => {
      dispatch(fetchRace(raceId));
    },
    setSelectedCandidate: (candidateId) => {
      dispatch(setSelectedCandidate(candidateId));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Races);
